<template>
  <div>
    <!-- BEGIN NAVBAR -->
    <NavHeader></NavHeader>
    <!-- END NAVBAR -->

    <!-- BEGIN MAIN CONTAINER -->
    <div
      class="main-container"
      id="container"
      :class="[!$store.state.is_show_sidebar ? 'sidebar-closed sbar-open' : '', $store.state.menu_style === 'collapsible-vertical' ? 'collapsible-vertical-mobile' : '']"
    >
      <!-- BEGIN OVERLAY -->
      <div
        class="overlay"
        v-shortkey="['ctrl', 'b']"
        @shortkey="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)"
        :class="{ show: !$store.state.is_show_sidebar }"
        @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)"
      ></div>
      <div
        class="search-overlay"
        :class="{ show: $store.state.is_show_search }"
        @click="$store.commit('toggleSearch', !$store.state.is_show_search)"
      ></div>
      <!-- END OVERLAY -->

      <!-- BEGIN SIDEBAR -->
      <Sidebar :pathURL="$route.path"></Sidebar>
      <!-- END SIDEBAR -->

      <!-- BEGIN CONTENT AREA -->
      <div
        id="content"
        class="main-content"
      >
        <router-view v-if="branchReady">
          <!-- BEGIN LOADER -->
          <div
            id="load_screen"
            v-if="loading"
          >
            <div class="loader">
              <div class="loader-content">
                <div class="spinner-grow align-self-center"></div>
              </div>
            </div>
          </div>
          <!-- END LOADER -->
          <!-- Actual content will be here, replace this comment with your actual content -->
        </router-view>

        <!-- BEGIN FOOTER -->
        <div class="d-flex justify-content-end mr-3">v1.7.3</div>
        <!-- <Footer></Footer> -->
        <!-- BEGIN COOKIE CONSENT -->
        <div
          v-if="!cookiesAccepted"
          class="cookie-consent"
        >
          <b-row>
            <b-col
              cols="1"
              class="mr-3"
            >
              <font-awesome-icon
                icon="cookie-bite"
                style="color: #fb9541; font-size: 50px"
              />
            </b-col>
            <b-col
              cols="9"
              md="8"
            >
              <h5 class="text-white">{{ $t('menu.cookie') }}</h5>
              <span class="text-white">{{ $t('menu.cookie-detail') }} </span>
              <a
                href="https://www.accrevo.com/aboutus/privacy"
                style="color: #00ffaa"
                >{{ $t('menu.privacy-policy') }}</a
              >
            </b-col>
            <b-col class="d-flex justify-content-center align-items-center">
              <b-button
                variant="success"
                @click="acceptCookies"
              >
                {{ $t('menu.accept-all') }}
              </b-button>
            </b-col>
          </b-row>
        </div>
        <!-- END COOKIE CONSENT -->
        <!-- END FOOTER -->
      </div>
      <!-- END CONTENT AREA -->

      <!-- BEGIN APP SETTING LAUNCHER -->
      <!-- <app-settings /> -->
      <!-- END APP SETTING LAUNCHER -->
    </div>
  </div>
</template>

<script>
  import NavHeader from '@/components/layout/NavHeader.vue';
  import Sidebar from '@/components/layout/sidebar.vue';

  export default {
    components: {
      NavHeader,
      Sidebar,
      // Footer,
      // appSettings,
    },
    data() {
      return {
        loading: false, // State to manage loading
        branchReady: true, // State to control the content rendering
        cookiesAccepted: localStorage.getItem('cookiesAccepted') === 'true',
      };
    },
    watch: {
      '$store.state.branchData': {
        handler(newBranchData) {
          this.reloadMainContent(newBranchData);
        },
        immediate: true,
      },
    },
    methods: {
      reloadMainContent() {
        this.loading = true;
        this.branchReady = false;
        setTimeout(() => {
          this.branchReady = true;
          this.loading = false;
        }, 500);
      },
      acceptCookies() {
        this.cookiesAccepted = true;
        localStorage.setItem('cookiesAccepted', 'true');
      },
    },
  };
</script>
